export const PortalRootId = {
    modalRoot: 'modalRoot',
    portalRoot: 'portalRoot',
    contractPortalRoot: 'contractPortalRoot',
    cameraPreviewRoot: 'cameraPreviewRoot',
    inquiryFormPortal: 'inquiryFormPortal',
} as const;

export type PortalRootIdType = keyof typeof PortalRootId;
